<template>
  <div>
    <div class="row">
      <div class="col">
        <div>
          <div class="form-group">
            <input
              v-model="searchText"
              class="form-control form-control-lg"
              type="text"
              placeholder=".form-control-lg"/>
          </div>
          <button type="button" class="btn btn-primary" v-on:click="search">Buscar</button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">

        <table class="table table-hover" v-if="listVersus">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr v-for="versus in listVersus.data" :key="versus.id">
              <th scope="row"> {{ versus.id }}</th>
              <td>
                <div class="imgav">
                  <div class="cAvatar">
                    <img :src="appDomainImg + 'profile/15.' + versus.student_creator.user.avatar" class="cImage"/>
                  </div>
                </div>
              </td>
              <td>{{ versus.student_creator.user.name}}</td>
              <td>{{ versus.score_creator}}</td>
              <td>
                <div class="imgav">
                  <div class="cAvatar">
                    <img :src="appDomainImg + 'profile/15.' + versus.student_friend.user.avatar" class="cImage"/>
                  </div>
                </div>
              </td>
              <td>{{ versus.student_friend.user.name}}</td>
              <td>{{ versus.score_friend}}</td>
              <td>{{ versus.status}}</td>
              <td>{{ versus.block.name}}</td>
              <td>{{ versus.course.name}}</td>
              <td>{{ versus.team.name}}</td>
              <td>{{ versus.level.name}}</td>
              <td>{{ versus.amount_questions}}</td>
              <td> </td>
              <td> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
//import { mapState } from "vuex";
import axios from 'axios'


export default {
  components: {
  },
  data() {
    return {
      listVersus: [],
      searchText: "",
      resSearch: [],
      viewSearch:false
      //    loading:true
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    getData() {
      const url = this.appDomainApi1 + "admin/versus/index"
      axios
        .get(url, 
        )
        .then((resp) => {
          this.listVersus = resp.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    search() {
      const url = this.appDomainApi1 + "admin/import/question/search";
      axios
        .post(
          url,
          { search: this.searchText },
        )
        .then((resp) => {
          if (resp.data.code == 200) {
            this.resSearch = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.imgav {
  display: flex;
  align-content: center;
  justify-content: center;
}
.cAvatar {
  position: relative;
  width: 30px;
  height: 30px;
  background-color: white;
  border-radius: 50%;
  overflow: hidden;
}
.cImage {
  position: absolute;
  width: 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.loading {
  height: 6.8em;
}
.dc1:hover {
  color: white;
  background: #628cfb;
  transition-duration: 100ms;
  cursor: pointer;
}
.dc1 {
  border-radius: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  background: #e8f0ff;
  margin: 5px;
}
.dDetalle:hover {
  color: white;
}
.dDetalle {
  padding-top: 10px;
}
.dDetalle > p {
  margin-top: 97px;
  /* margin: -15px; */
  margin-left: 6px;
  padding: 0px;
  /* border: 0px; */
  margin-top: -15px;
  font-size: 16px;
  color: #1d2b8d;
  line-height: 1.2;
}
.nutemas {
  color: black;
  margin-left: 16px;
  font-family: inherit;
  font-size: 50px;
}
</style>
